module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.galleryPreview['sizes']['gallery-thumb']
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.gallery.gallery_name)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b26860e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery/GalleryThumb.vue
// module id = 321
// module chunks = 1